import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, Transition as _Transition, withCtx as _withCtx, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "dashboard-main" }
const _hoisted_2 = { class: "sticky top-0 z-20 border-b border-white/10 bg-brand-900/80 backdrop-blur" }
const _hoisted_3 = { class: "mx-auto flex min-h-[60px] max-w-[1600px] items-center justify-between gap-2 px-3 py-1.5 sm:px-4 lg:px-6" }
const _hoisted_4 = { class: "flex min-w-0 items-center gap-2 text-white" }
const _hoisted_5 = { class: "flex shrink-0 items-center gap-1.5 text-white" }
const _hoisted_6 = {
  class: "flex min-h-8 shrink-0 items-center gap-1.5 rounded-lg border border-white/15 bg-white/10 px-2 py-1 shadow-sm backdrop-blur",
  title: "Thời gian hiện tại"
}
const _hoisted_7 = { class: "text-right leading-none" }
const _hoisted_8 = { class: "font-mono text-xs font-bold tabular-nums tracking-wide" }
const _hoisted_9 = { class: "mt-0.5 whitespace-nowrap text-[8px] font-medium text-blue-100 sm:text-[9px]" }
const _hoisted_10 = { class: "hidden min-h-9 shrink-0 items-center gap-1.5 rounded-full border border-white/15 bg-white/10 px-2 py-1 md:flex" }
const _hoisted_11 = { class: "grid h-6 w-6 shrink-0 place-items-center rounded-full bg-white text-[11px] font-bold text-brand-700" }
const _hoisted_12 = { class: "max-w-[220px] text-left leading-none" }
const _hoisted_13 = { class: "truncate text-[11px] font-semibold leading-4" }
const _hoisted_14 = { class: "truncate text-[10px] leading-3 text-blue-100" }
const _hoisted_15 = {
  key: 2,
  class: "fixed inset-0 z-[100] grid place-items-center bg-slate-950/60 p-4 backdrop-blur-sm",
  role: "dialog",
  "aria-modal": "true",
  "aria-labelledby": "session-expired-title"
}
const _hoisted_16 = { class: "w-full max-w-md rounded-3xl border border-slate-200 bg-white p-6 text-center shadow-2xl sm:p-8" }
const _hoisted_17 = { class: "mx-auto grid h-14 w-14 place-items-center rounded-2xl bg-amber-50 text-amber-600" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_UiToastHost = _resolveComponent("UiToastHost")!
  const _component_LoginPage = _resolveComponent("LoginPage")!
  const _component_TopNavBar = _resolveComponent("TopNavBar")!
  const _component_UiButton = _resolveComponent("UiButton")!
  const _component_Clock = _resolveComponent("Clock")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_ShieldAlert = _resolveComponent("ShieldAlert")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_UiToastHost),
    ($setup.showLogin)
      ? (_openBlock(), _createBlock(_component_LoginPage, { key: 0 }))
      : (_openBlock(), _createElementBlock("div", {
          key: 1,
          class: _normalizeClass([
      'dashboard-shell',
      $setup.sidebarCollapsed
        ? 'lg:grid-cols-[64px_minmax(0,1fr)] xl:grid-cols-[68px_minmax(0,1fr)]'
        : 'lg:grid-cols-[210px_minmax(0,1fr)] xl:grid-cols-[220px_minmax(0,1fr)]',
    ])
        }, [
          _createVNode(_Transition, { name: "fade" }, {
            default: _withCtx(() => [
              ($setup.mobileOpen)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    class: "fixed inset-0 z-30 bg-slate-950/50 lg:hidden",
                    "aria-label": "Đóng menu",
                    onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.mobileOpen = false))
                  }))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }),
          _createElementVNode("aside", {
            class: _normalizeClass([
        'fixed inset-y-0 left-0 z-40 w-[min(84vw,240px)] transform transition-all duration-200 lg:static lg:translate-x-0',
        $setup.sidebarCollapsed ? 'lg:w-[64px] xl:w-[68px]' : 'lg:w-[210px] xl:w-[220px]',
        $setup.mobileOpen ? 'translate-x-0' : '-translate-x-full',
      ])
          }, [
            _createVNode(_component_TopNavBar, {
              "full-name": $setup.fullName,
              team: $setup.team,
              collapsed: $setup.sidebarCollapsed && !$setup.mobileOpen,
              onToggleCollapse: _cache[1] || (_cache[1] = ($event: any) => ($setup.sidebarCollapsed = !$setup.sidebarCollapsed)),
              onNavigate: _cache[2] || (_cache[2] = ($event: any) => ($setup.mobileOpen = false))
            }, null, 8, ["full-name", "team", "collapsed"])
          ], 2),
          _createElementVNode("main", _hoisted_1, [
            _createElementVNode("header", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, [
                  _createVNode(_component_UiButton, {
                    variant: "ghost",
                    size: "icon",
                    icon: "menu",
                    class: "bg-white/10 text-white hover:bg-white/20 lg:hidden",
                    onClick: _cache[3] || (_cache[3] = ($event: any) => ($setup.mobileOpen = true))
                  }),
                  _cache[4] || (_cache[4] = _createElementVNode("div", { class: "min-w-0 text-left leading-none" }, [
                    _createElementVNode("p", { class: "truncate text-[11px] font-medium leading-4 text-blue-100" }, " Hệ thống quản lý tài sản "),
                    _createElementVNode("p", { class: "truncate text-base font-black leading-6 sm:text-lg" }, " Dashboard vận hành ")
                  ], -1))
                ]),
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("div", _hoisted_6, [
                    _createVNode(_component_Clock, {
                      size: 14,
                      "stroke-width": 2,
                      class: "hidden text-blue-100 sm:block"
                    }),
                    _createElementVNode("div", _hoisted_7, [
                      _createElementVNode("p", _hoisted_8, _toDisplayString($setup.currentTimeText), 1),
                      _createElementVNode("p", _hoisted_9, _toDisplayString($setup.currentDateText), 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_10, [
                    _createElementVNode("div", _hoisted_11, _toDisplayString($setup.initials), 1),
                    _createElementVNode("div", _hoisted_12, [
                      _createElementVNode("p", _hoisted_13, _toDisplayString($setup.fullName || "Người dùng"), 1),
                      _createElementVNode("p", _hoisted_14, _toDisplayString($setup.team || "Chưa có khoa/phòng"), 1)
                    ])
                  ])
                ])
              ])
            ]),
            _createVNode(_component_router_view)
          ])
        ], 2)),
    ($setup.sessionExpired)
      ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
          _createElementVNode("div", _hoisted_16, [
            _createElementVNode("div", _hoisted_17, [
              _createVNode(_component_ShieldAlert, {
                size: 30,
                "stroke-width": 2
              })
            ]),
            _cache[6] || (_cache[6] = _createElementVNode("h2", {
              id: "session-expired-title",
              class: "mt-5 text-xl font-black text-slate-900"
            }, " Phiên đăng nhập đã hết hạn ", -1)),
            _cache[7] || (_cache[7] = _createElementVNode("p", { class: "mt-2 text-sm leading-6 text-slate-600" }, " Tài khoản đã hết hạn đăng nhập. Vui lòng đăng nhập lại để tiếp tục sử dụng hệ thống. ", -1)),
            _createVNode(_component_UiButton, {
              class: "mt-6",
              icon: "login",
              size: "lg",
              block: "",
              onClick: $setup.goToRelogin
            }, {
              default: _withCtx(() => [...(_cache[5] || (_cache[5] = [
                _createTextVNode(" Đăng nhập lại ", -1)
              ]))]),
              _: 1
            }, 8, ["onClick"])
          ])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}